import React from 'react';

const Malote: React.FC = () => {
    return (
        <div>
            <h1>Malote</h1>
        </div>
    );
};

export default Malote;
